import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import { BrowserRouter as Router, Route } from "react-router-dom";
import axios from "axios";
import "./i18n";
import Authenticate from "./components/Authenticate";
import { isUrlPathActive, isConfidentialInfo } from "./utils/urlHelper";

import NavPortal from "./InfoBar/NavPortal";
//import "~/bootstrap/dist/css/bootstrap.min.css"
import "react-toastify/dist/ReactToastify.css";
import "./styles/bootstrap.overides.scss";
// import "react-jsonschemapath-form/dist/index.css";
import "@qjumpers/common-ui/dist/index.css";
import ProtectedRoutes from "./routes/protectedRoutes";
import ConfidentialQuestionnaire from "./components/Form/ApplicationForm/ConfidentialQuestionnaire";

const dest = document.getElementById("root");

const App = () => {
  const isQuickApply = isUrlPathActive("quickapplications");
  const isConfidentialQuickApply = isUrlPathActive("confidentialquickapply") && isConfidentialInfo("link");

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        /*eslint-disable*/
        const { data: response } = await axios.get(`${environmentConfig.ADMIN.apiHost}/keycloak`);
        /*eslint-enable*/
        const requiredData = {
          realm: response["realm"],
          url: response["auth-server-url"],
          clientId: response["resource"],
        };
        setData(requiredData);
        setLoading(false);
      } catch (error) {
        console.error(error.message);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <>
      {isQuickApply && (
        <>
          <NavPortal />
          <Route path="/*" render={() => <ProtectedRoutes />} />
        </>
      )}
      {isConfidentialQuickApply && <ConfidentialQuestionnaire />}
      {!isConfidentialQuickApply && !isQuickApply && (
        <div>
          <NavPortal />
          <Authenticate data={data} />
        </div>
      )}
    </>
  );
};

if (dest) {
  ReactDOM.render(
    <RecoilRoot>
      <Router>
        <App />
      </Router>
    </RecoilRoot>,
    dest
  );
}
